import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { ListObservable } from '../../shared/base/list-observable';
import { Course } from '../shared/course';
import { CourseUserService } from '../shared/course-user.service';

@Component({
  selector: 'app-course-member-list',
  templateUrl: './course-member-list.component.html'
})
export class CourseMemberListComponent implements OnChanges {
  @Input() course: Course;
  usersObservable: ListObservable<any>;

  constructor(private refService: CourseUserService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['course']) {
      this.usersObservable = this.refService.readList(this.course.$key);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-member-list/course-member-list.component.ts